<template>
  <SACModal
    modalClass="promo-plans-modal"
    :cardClass="`promo-plans-${view}`"
    :show="show"
    :close="close"
  >
    <template #content>
      <div class="ac-card-content">
        <div class="ac-body-container">
          <div class="flex-row just-between align-start" style="width: 100%">
            <div class="ac-header">Eligible Plans</div>
            <button @click="close"><span class="icon-luc-X" /></button>
          </div>
          <div class="ac-plan-body" v-for="plan in plans">
            • {{ allPlans.find((x) => x.planId === plan)?.name }} ({{
              allPlans.find((x) => x.planId === plan)?.planType === "Hardware"
                ? "Detect"
                : "Connect"
            }})
          </div>
        </div>
      </div>
    </template>
  </SACModal>
</template>
<script>
import SACModal from "@shared/components/sac/SACModal.vue";
import PromoInfo from "./infoModal/PromoInfo.vue";
import OfferSummary from "./infoModal/OfferSummary.vue";
import AddImage from "./infoModal/AddImage.vue";
import PromotionInfo from "./infoModal/PromotionInfo.vue";

export default {
  name: "OfferPlansModal",
  components: {
    SACModal,
    PromoInfo,
    OfferSummary,
    AddImage,
    PromotionInfo,
  },
  props: {
    show: Boolean,
    view: String,
    close: Function,
    plans: Array,
    allPlans: Array,
  },
};
</script>
<style lang="scss">
.promo-plans-modal {
  .promo-plans-info {
    width: 500px;
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.5s ease;
    max-height: 90vh;
    .ac-body-container {
      flex: 1;
      padding: 15px 25px;
      display: flex;
      flex-direction: column;
      align-items: start;
      .ac-logo {
        width: 120px;
        margin-bottom: 10px;
        object-fit: contain;
      }
      .ac-plan-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        border: 1px solid $N5;
        border-radius: 6px;
        padding: 13px 23px;
        width: 90%;
        &:not(:first-child) {
          margin-top: 12px;
        }
        .ac-plan-header {
          display: flex;
          align-items: center;
          font-size: 1rem;
          text-align: start !important;
          font-weight: 400;
          color: $NAVY100;
          img {
            margin-right: 11px;
          }
        }
        .ac-plan-body-header {
          font-size: 0.75rem;
          color: $NAVY100;
          font-weight: 600;
        }
        .ac-plan-body {
          font-size: 0.6875rem;
          color: $N90;
          text-align: center;
        }
      }
      .ac-button {
        padding: 2px 9px;
        font-size: 0.625rem;
        color: $N90;
        background-color: #cad7ff;
        border-radius: 3px;
        margin-top: 48px;
      }
      .ac-header {
        text-align: center;
        font-size: 1.25em;
        margin-bottom: 24px;
        font-weight: 500;
      }
      .ac-info-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        border: 1px solid $N5;
        border-radius: 6px;
        padding: 13px 23px;
        .ac-info-header {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1em;
          font-weight: 400;
          color: $NAVY100;
          img {
            margin-right: 11px;
          }
        }
        .ac-info-body {
          margin-top: 8px;
          font-size: 0.875em;
          color: $N90;
        }
      }
      .ac-button-container {
        display: flex;
        align-items: center;
        justify-content: center;
        .ac-button {
          padding: 4px 16px;
          background-color: #cad7ff;
          border-radius: 4px;
          font-size: 0.75em;
          &:not(:first-child) {
            margin-left: 8px;
            background-color: $NBLUE100;
            color: $WHITE;
          }
        }
      }
    }
  }
}
</style>
